import { getCompanyId, loadStyle } from 'globalutils/fmUtils';
import moment from 'moment-timezone';
import PropTypes from 'prop-types';
import React, { lazy, useMemo } from 'react';
import { useParams } from 'react-router-dom';
import RenderComponent from './RenderComponent';
import { getSchema } from './schema';
import ParentStyled from './style';

const Styled = loadStyle(ParentStyled, 'modules/FuelComsumptionAddEdit');
const layout = window?.$environment?.CURRENT_LAYOUT;
const Form = lazy(() => import(`globalcomponents/UI/Form/${layout}`));

const Component = ({
  closeModal,
  saveDocument,
  uploadApi,
  callback,
  parent,
  types,
  currentData,
  vehicleList,
  driverList,
  stateListData,
}) => {
  const match = useParams();
  const companyId = getCompanyId();

  const stateArrayFromDiffFields = (list, value, field1) => {
    return list && Object.keys(list)?.length
      ? Object.keys(list).flatMap((state) =>
          list[state].map((item) => {
            return {
              label: `${item[field1]} (${state})`,
              value: item[value],
            };
          })
        )
      : [];
  };

  function removeEmptyKeys(obj) {
    Object.keys(obj).forEach((key) => {
      if (obj[key] === null || obj[key] === undefined || obj[key] === '') {
        delete obj[key];
      } else if (typeof obj[key] === 'object') {
        removeEmptyKeys(obj[key]);
        if (Object.keys(obj[key]).length === 0) {
          delete obj[key];
        }
      }
    });
    return obj;
  }

  const stateList = useMemo(() => stateArrayFromDiffFields(stateListData?.State, 'key', 'displayName'), [stateListData]);

  const instialState = useMemo(() => {
    if (currentData)
      return {
        id: currentData?.id || '',
        driver: currentData?.driverId
          ? driverList.find((el) => {
              return el.value === currentData.driverId;
            }) || {}
          : {},
        vehicle: currentData?.vehicle
          ? vehicleList.find((el) => {
              return el.value === currentData.vehicle;
            }) || {}
          : {},
        jurisdiction: currentData?.jurisdiction
          ? stateList.find((el) => {
              return el.value === currentData.jurisdiction;
            }) || {}
          : {},
        cost: currentData?.cost || '',
        odometer: currentData?.odometr || '',
        amount: currentData?.amount || '',
        date: currentData?.date ? moment(currentData?.date).tz(moment.tz.guess()).format('MM/DD/YYYY') : '',
        location: currentData?.location || '',
      };
    return {};
  }, [currentData, driverList, vehicleList, stateList]);

  const modifyDocumentType = (data) => ({
    ...data,
    receipts: data.receipts.map((r) => ({
      ...r,
      documentType: r.documentType?.name,
    })),
  });

  const handleSubmit = (fields) => {
    const requestData = removeEmptyKeys({
      id: currentData?.id || '',
      companyId: companyId || '',
      vehicle: fields?.vehicle?.value || '',
      driverId: fields?.driver?.value || '',
      jurisdiction: fields?.jurisdiction?.value || '',
      location: fields?.location || '',
      cost: fields?.cost || '',
      odometr: fields?.odometer || '',
      amount: fields?.amount || '',
      date: fields?.date ? moment(fields?.date, 'MM/DD/YYYY').format('YYYY-MM-DD') : '',
    });
    if (document?.querySelectorAll('span.filepond--file-status-main')[0]?.innerText === '' || currentData?.id) {
      const payloadData = {
        apiId: uploadApi,
        param: currentData ? { ...modifyDocumentType(currentData), ...requestData } : requestData,
        data: { data: { file: fields?.upload?.[0] || null } },
        callback,
        ...(match?.id && { refillHistoryId: match.id }),
      };
      saveDocument(payloadData);
      closeModal();
    }
  };

  return (
    <Styled.Wrapper>
      <Form
        type="server"
        direction="column"
        initialValues={instialState}
        RenderComponent={RenderComponent}
        handleOnSubmit={handleSubmit}
        customProps={{ parent, types, Styled, vehicleList, driverList, stateList }}
        handleClear={() => {}}
        validationSchema={getSchema(currentData)}
      />
    </Styled.Wrapper>
  );
};

export default Component;

Component.propTypes = {
  apiStatus: PropTypes.object,
  callback: PropTypes.func.isRequired,
};
